module.exports = __webpack_public_path__ + "static/profile-pic-28f5d7806713f97adf697d5907f0f0c7.png";